<template>
  <div class="content">
    <el-card>
        <div slot="header">
          <el-button style="float: left; padding: 3px 0" type="text" @click="immediateWithdrawalClick" v-hasPermi="['withdraw:immediateWithdrawal']">立即提现</el-button>
        </div>
        <el-row>
          <el-col :span="24">
            <el-descriptions :labelStyle="{'text-align': 'center'}"  :contentStyle="{'text-align': 'center'}" :column="6" direction="vertical" border>
               <el-descriptions-item>
                  <template slot="label">
                    <svg-icon icon-class="comission"/>
                    佣金总金额
                    <el-tooltip content="截止当日未提现佣金总额" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  {{userCommissionInfo.totalCommissionAmount}}
              </el-descriptions-item>
              <el-descriptions-item>
                  <template slot="label">
                    <svg-icon icon-class="balance"/>
                    可提现金额
                    <el-tooltip content="截止上月底可提现佣金总额（当月15日之后可提上月及之前所有佣金）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  {{userCommissionInfo.availCommissionAmount}}
              </el-descriptions-item>
              <el-descriptions-item>
                  <template slot="label">
                    <svg-icon icon-class="cert"/>
                    实名认证
                  </template>
                  <el-tag size="small" v-if="userWithdrawInfo.userCertStatus==1" type="warning" effect="plain" style="margin-right:8px">审核中</el-tag>
                  <el-tag size="small" v-else-if="userWithdrawInfo.userCertStatus==2" type="success" effect="plain" style="margin-right:8px">已认证</el-tag>
                  <el-tag size="small" v-else-if="userWithdrawInfo.userCertStatus==3" type="danger" effect="plain" style="margin-right:8px">认证失败</el-tag>
                  <el-tag size="small" v-else type="warning" effect="plain" style="margin-right:8px">未认证</el-tag>

                  <el-tag size="small" v-if="userWithdrawInfo.userCertStatus==1 || userWithdrawInfo.userCertStatus==2" type="info" effect="dark" class="el-icon-arrow-right" @click="authenticationInfo" style="cursor: pointer;">实名信息</el-tag>
                  <el-tag size="small" v-else effect="dark" class="el-icon-arrow-right" @click="authenticationBind" style="cursor: pointer;">去实名</el-tag>
              </el-descriptions-item>
              <el-descriptions-item v-if="checkPermi(['withdraw:account:wx'])">
                  <template slot="label">
                    <svg-icon icon-class="wechat"/>
                    微信账号
                  </template>
                  <el-tag size="small" v-if="userWithdrawInfo.userWxBind==0" type="warning" effect="plain" style="margin-right:8px">未绑定</el-tag>
                  <el-tag size="small" v-else type="success" effect="plain" style="margin-right:8px">已绑定</el-tag>

                  <el-tag size="small" effect="dark" v-if="userWithdrawInfo.userWxBind==0" class="el-icon-arrow-right" @click="wechatBind" style="cursor: pointer;">去绑定</el-tag>
                  <el-tag size="small" v-else type="info" effect="dark" class="el-icon-arrow-right" @click="wechatBindInfo" style="cursor: pointer;">微信绑定信息</el-tag>
              </el-descriptions-item>
              <el-descriptions-item v-if="checkPermi(['withdraw:account:bank'])">
                  <template slot="label">
                    <i class="el-icon-bank-card"></i>
                    银行账号
                  </template>
                  <el-tag size="small" v-if="userWithdrawInfo.userBankBind==0" type="warning" effect="plain" style="margin-right:8px">未绑定</el-tag>
                  <el-tag size="small" v-else-if="userWithdrawInfo.userBankBind==1" type="warning" effect="plain" style="margin-right:8px">审核中</el-tag>
                  <el-tag size="small" v-else-if="userWithdrawInfo.userBankBind==3" type="danger" effect="plain" style="margin-right:8px">审核失败</el-tag>
                  <el-tag size="small" v-else type="success" effect="plain" style="margin-right:8px">已绑定</el-tag>

                  <el-tag size="small" v-if="userWithdrawInfo.userBankBind==0 || userWithdrawInfo.userBankBind==3" effect="dark" class="el-icon-arrow-right" @click="bankBind" style="cursor: pointer;">去绑定</el-tag>
                  <el-tag size="small" v-else type="info" effect="dark" class="el-icon-arrow-right" @click="bankBindInfoMethod" style="cursor: pointer;">银行绑定信息</el-tag>
              </el-descriptions-item>
              <el-descriptions-item v-if="checkPermi(['withdraw:account:alipay'])">
                  <template slot="label">
                    <svg-icon icon-class="alipay"/>
                    支付宝账号
                  </template>
                  <el-tag size="small" v-if="userWithdrawInfo.userAlipayBind==0" type="warning" effect="plain" style="margin-right:8px">未绑定</el-tag>
                  <el-tag size="small" v-else type="success" effect="plain" style="margin-right:8px">已绑定</el-tag>

                  <el-tag size="small" effect="dark" v-if="userWithdrawInfo.userAlipayBind==0" class="el-icon-arrow-right" @click="apliayBind" style="cursor: pointer;">去绑定</el-tag>
                  <el-tag size="small" v-else type="info" effect="dark" class="el-icon-arrow-right" @click="alipayBindInfo" style="cursor: pointer;">支付宝绑定信息</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
    </el-card>
    <el-card style="margin-top:6px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="提现申请记录" name="withdrawRecord">
              <el-form :model="withdrawRecordParams" ref="withdrawRecordParams"  :inline="true">
                <el-form-item prop="orderStatus">
                  <el-select
                    v-model="withdrawRecordParams.orderStatus"
                    placeholder="审核状态"
                    multiple
                    clearable
                  >
                    <el-option
                    v-for="item in state"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="dateWithdrawRange">
                    <el-date-picker
                      v-model="dateWithdrawRange"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="申请开始日期"
                      end-placeholder="申请结束日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
              </el-form>
              <el-table :data="withdrawRecordData" border style="width: 100%">
                  <el-table-column fixed prop="orderId" label="提现订单号" align="center" width="150"></el-table-column>
                  <el-table-column prop="orderMoney" label="提现金额" align="center" width="100"></el-table-column>
                  <el-table-column fixed prop="actualAmount" label="实际到账金额" align="center" width="150"></el-table-column>
                  <el-table-column prop="serviceCharge" label="提现手续费" align="center" width="120"></el-table-column>
                  <el-table-column prop="taxMoney" label="税金" align="center" width="120"></el-table-column>
                  <el-table-column prop="orderStatus" label="状态" align="center" width="120">
                    <template slot-scope="scope">
                      {{ inventoryOrderStatus(scope.row.orderStatus) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="payMode" label="提现方式" align="center" width="120">
                      <template slot-scope="scope">
                        {{ inventoryPayMode(scope.row.payMode) }}
                      </template>
                  </el-table-column>
                  <el-table-column prop="dateRange" label="结算时段" align="center" width="220"></el-table-column>
                  <el-table-column prop="orderTime" label="申请时间" align="center" width="220"></el-table-column>
                  <el-table-column prop="auditTime" label="审核时间" align="center" width="220"></el-table-column>
                  <el-table-column prop="withdrawalRemark" label="申请备注" align="center" width="120"></el-table-column>
                  <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                      <el-button  size="mini" type="primary" plain icon="el-icon-view"  @click="withdrawRecordView(scope.row.id)" >查看</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <pagination
                  v-show="totalWithdrawRecord>0"
                  :total="totalWithdrawRecord"
                  :page.sync="withdrawRecordPage"
                  :limit.sync="withdrawRecordPageSize"
                  @pagination="pageUserWithdrawalMethod"
                  @changePageNo="handleWithdrawRecordCurrentChange"
                  @changePageSize="handleWithdrawRecordSizeChange"
                />
          </el-tab-pane>
          <el-tab-pane label="可提现明细" name="withdrawableDetail" class="withdrawable-detail">
            <el-form :model="withdrawableParams" ref="withdrawableParams" :inline="true">
                <el-form-item prop="datewithdrawableRange">
                    <el-date-picker
                      v-model="datewithdrawableRange"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="佣金开始日期"
                      end-placeholder="佣金结束日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search"  @click="searchWithdrawable">搜索</el-button>
                  <el-button icon="el-icon-refresh"  @click="resetWithdrawableQuery">重置</el-button>
                </el-form-item>
            </el-form>
            <el-row :gutter="20">
              <el-col :span="8">
                <div>
                  <el-statistic group-separator="," :precision="2" :value="countWithdrawable.totalRealPayAmount" title="总订单金额"></el-statistic>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic group-separator="," :precision="2" :value="countWithdrawable.totalRebateAmount" title="总分润金额"></el-statistic>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic group-separator="," :precision="2" :value="countWithdrawable.totalRealRebateAmount" title="总实分润金额"></el-statistic>
                </div>
              </el-col>
            </el-row>
            <el-table :data="withdrawableDetailData" border style="width: 100%">
              <el-table-column fixed prop="iccid" label="卡号" align="center" ></el-table-column>
              <el-table-column fixed prop="companyName" label="下级代理商名称" align="center" ></el-table-column>
              <el-table-column fixed prop="orderNum" label="订单号" align="center" ></el-table-column>
              <el-table-column fixed prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
              <el-table-column fixed prop="realPayAmount" label="订单金额" align="center"></el-table-column>
              <el-table-column fixed prop="totalRebateAmount" label="总分润" align="center"></el-table-column>
              <el-table-column fixed prop="realRebateAmount" label="实分润" align="center"></el-table-column>
              <el-table-column fixed prop="subRealRebateAmount" label="下级分润" align="center"></el-table-column>
            </el-table>
            <pagination
                  v-show="totalWithdrawable>0"
                  :total="totalWithdrawable"
                  :page.sync="withdrawablePage"
                  :limit.sync="withdrawablePageSize"
                  @pagination="userCommissionWithdrawMethod"
                  @changePageNo="handleWithdrawableCurrentChange"
                  @changePageSize="handleWithdrawableSizeChange"
                />
          </el-tab-pane>
          <el-tab-pane label="收款账号" name="account">
            <el-table :data="accountData" border style="width: 100%">
              <el-table-column fixed prop="type" label="收款类型" align="center" ></el-table-column>
              <el-table-column fixed prop="accountNumber" label="收款账号" align="center" ></el-table-column>
              <el-table-column fixed prop="createTime" label="绑定时间" align="center" width="180"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
    </el-card>
    <!-- 立即提现弹窗 -->
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="700px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="formData">
        <p style="color:red">提现请在工作日内发起提交。</p>
        <el-form-item label="请选择提现方式:" prop="payMode" >
          <el-radio-group v-model="formData.payMode" @change="calculateAmountMoneyMethod()">
            <el-radio   label="1" :disabled="userWithdrawInfo.userWxBind != 1" >微信（T+1）
                <el-tooltip content="微信单日账号提现总金额必须小于2万元" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </el-radio>
            <el-radio   label="2" >支付宝
              <el-tooltip content="支付宝单日账号提现总金额必须小于5万元" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </el-radio>
            <el-radio   label="3" >个人余额</el-radio>
            <el-radio   label="4" :disabled="userWithdrawInfo.userBankBind != 2" >对公账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="对公银行" prop="bank" label-width="160px" v-if="formData.payMode==4">
          <el-select v-model="formData.bank" placeholder="请选择" style="width: 350px;">
            <el-option 
              v-for="item in dataBank"
              :key="item.bankAccount"
              :label='"【"+item.bank+"】"+item.bankAccount'
              :value="item.bankAccount">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算开始日期" prop="beginDate" label-width="160px">
          <el-input v-model="formData.beginDate" autocomplete="off"  disabled style="width:350px"></el-input>
        </el-form-item>

        <el-form-item label="请选择分润结算日期" prop="endMonth" label-width="160px">
          <el-date-picker  v-model="formData.endMonth" type="month" placeholder="选择月" value-format="yyyy-MM" :picker-options="pickerOptionsEnd" @change="pickerTimeWithdrawMethod" style="width:350px"></el-date-picker>

          <!-- <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="formData.endDate" :editable="false" :picker-options="pickerOptionsEnd" @change="pickerTimeWithdrawMethod" style="width:350px"></el-date-picker> -->
        </el-form-item>

        <el-form-item label="提现金额:" prop="orderMoney" label-width="160px">
          <el-input v-model="formData.orderMoney" autocomplete="off" style="width:350px" disabled></el-input>
        </el-form-item>
        <el-form-item  prop="amountMoney" label-width="160px">
          <span slot="label">
            <el-tooltip content="扣除税金和手续费后的金额" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
            实际到账金额:
          </span>
          <el-input v-model="formData.amountMoney" autocomplete="off" style="width:350px" disabled></el-input>
        </el-form-item>
        <el-form-item  prop="free" label-width="160px">
          <span slot="label">
            <el-tooltip content="指此次提现产生的交税金额" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
            税率:
          </span>
          <el-input v-model="formData.taxRate" autocomplete="off" style="width:350px" disabled>
          </el-input>
        </el-form-item>
        <el-form-item  prop="free" label-width="160px">
          <span slot="label">
            <el-tooltip content="指此次提现平台需要扣除的手续费" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
            手续费率:
          </span>
          <el-input v-model="formData.free" autocomplete="off" style="width:350px" disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码:" prop="code" label-width="160px">
          <el-input v-model="formData.code" style="width:350px"></el-input>
          <el-button v-show="withdrawalCountDown" type="primary"  @click="sendWithdrawCode(phone,formData.orderMoney)">获取验证码</el-button>
          <el-button v-show="!withdrawalCountDown" type="primary" >{{withdrawalCount}}s后可重发</el-button>

          <p v-if="userWithdrawInfo.userCertStatus==2" style="height:28px;font-size:12px">验证码将发送到<strong style="font-size:16px">{{this.phone}}</strong>号码上，请注意查收</p>
          <p v-else style="height:28px;font-size:12px;color:red">实名认证成功后，才能获取手机号！</p>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" label-width="160px">
          <el-input type="textarea" v-model="formData.remark" autocomplete="off" style="width:350px"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer" v-show="userWithdrawInfo.userCertStatus==2">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="submitWithdraw">确认</el-button>
      </div>
    </el-dialog>
    <!-- 微信认证绑定 -->
    <el-dialog :title="wechatTitle" :visible.sync="showWechatDialog" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-steps :active="wechatActive" align-center>
        <el-step title="短信验证" description="实名认证手机号"></el-step>
        <el-step title="微信绑定" description="绑定成功后，可以提现到此微信账号"></el-step>
      </el-steps>
      <el-form style="margin-top:30px;"  :model="wechatForm" ref="wechatForm" :rules="wechatRules"  label-width="150px" v-if="wechatActive==1">
          <el-form-item label="手机号：" >
            <el-row>
              <el-col :span="16">
                  <el-input v-model="wechatForm.phone" :disabled="true"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码：" prop="code" >
            <el-row :gutter="4">
              <el-col :span="16">
                  <el-input v-model="wechatForm.code" style="width: 100%;" placeholder="验证码"></el-input>
              </el-col>
              <el-col :span="4">
                  <el-button v-show="showCountDown" type="primary" @click="sendCode('wechat',wechatForm.phone)">发送验证码</el-button>
                  <el-button v-show="!showCountDown" type="primary" >{{count}}s后可重发</el-button>
              </el-col>
            </el-row> 
          </el-form-item>
      </el-form>
      <div class="wecaht-image" v-if="wechatActive==2">
        <div class="block">
          <span class="demonstration">扫码绑定微信收款账号</span>
          <el-image :src="scanWxQrCode"></el-image>
        </div>
      </div>
      <div class="dialog-footer" slot="footer" >
        <el-button type="success" v-if="wechatActive==1" @click="nextWechat">下一步</el-button>
      </div>
    </el-dialog>
    <el-dialog title="微信绑定信息" :visible.sync="showWxInfoDialog" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-descriptions class="margin-top" :column="2" size="medium">
        <el-descriptions-item label="收款账号">{{userWxAccountNumber.accountNumber}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{userWxAccountNumber.createTime}}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{userWxAccountNumber.nickname}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 银行卡绑定 -->
    <el-dialog :title="bankTitle" :visible.sync="showBankDialog" @close="dialogBankClose" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-steps :active="bankActive" align-center>
        <el-step title="短信验证" description="实名认证手机号"></el-step>
        <el-step title="对公账号绑定" description="绑定成功后，可以提现转账到此银行账号"></el-step>
      </el-steps>
      <el-form style="margin-top:30px;"  :model="bankForm" ref="bankForm" :rules="backRules"  label-width="150px" v-if="bankActive==1">
          <el-form-item label="手机号：" >
            <el-row>
              <el-col :span="16">
                  <el-input v-model="bankForm.phone" :disabled="true"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码：" prop="code" >
            <el-row :gutter="4">
              <el-col :span="16">
                  <el-input v-model="bankForm.code" style="width: 100%;" placeholder="验证码"></el-input>
              </el-col>
              <el-col :span="4">
                  <el-button v-show="showCountDown" type="primary" @click="sendCode('bank',bankForm.phone)">发送验证码</el-button>
                  <el-button v-show="!showCountDown" type="primary" >{{count}}s后可重发</el-button>
              </el-col>
            </el-row> 
          </el-form-item>
      </el-form>
      <el-form style="margin-top:30px;"  :model="bankAccountForm" ref="bankAccountForm" :rules="backAccountRules"  label-width="150px" v-if="bankActive==2">
          <el-form-item label="开户银行：" prop="bank">
                <el-input v-model="bankAccountForm.bank"></el-input>
          </el-form-item>
          <el-form-item label="开户账号：" prop="bankAccount">
                <el-input v-model="bankAccountForm.bankAccount"></el-input>
          </el-form-item>
          <el-form-item label="公司联系方式：" prop="businessPhone">
                <el-input v-model="bankAccountForm.businessPhone"></el-input>
          </el-form-item>
          <el-form-item label="公司注册地址：" prop="businessAddress">
                <el-input v-model="bankAccountForm.businessAddress"></el-input>
          </el-form-item>
          <el-form-item label="备注："  v-if="bankAccountForm.auditStatus == '审核不通过'">
                <el-input type="textarea" disabled="true" v-model="bankAccountForm.remark"></el-input>
          </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer" >
        <el-button type="success" v-if="bankActive==1" @click="nextBack">下一步</el-button>
        <el-button type="success" v-if="bankActive==2" @click="submitBank">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="银行绑定信息" :visible.sync="showBankDetailDialog" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-descriptions style="margin-left:20px" :labelStyle="{'color': '#333','font-weight': 700}"  :column="2" direction="vertical" border>
        <el-descriptions-item label="开户行">{{userBankInfo.bank}}</el-descriptions-item>
        <el-descriptions-item label="开户账号">{{userBankInfo.bankAccount}}</el-descriptions-item>
        <el-descriptions-item label="公司联系方式">{{userBankInfo.businessPhone}}</el-descriptions-item>
        <el-descriptions-item label="公司注册地址">{{userBankInfo.businessAddress}}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{userBankInfo.createTime}}</el-descriptions-item>
        <el-descriptions-item label="审核状态">{{userBankInfo.auditStatus}}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{userBankInfo.auditTime}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{userBankInfo.remark}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 支付宝绑定 -->
    <el-dialog title="支付宝绑定流量" :visible.sync="showAlipayDialog" @close="dialogAlipayClose" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-steps :active="alipayActive" align-center>
        <el-step title="短信验证" description="实名认证手机号"></el-step>
        <el-step title="支付宝绑定" description="绑定成功后，可以提现转账到此支付宝账号"></el-step>
      </el-steps>
      <el-form style="margin-top:30px;"  :model="alipayForm" ref="alipayForm" :rules="alipayRules"  label-width="150px" v-if="alipayActive==1">
          <el-form-item label="手机号：" >
            <el-row>
              <el-col :span="16">
                  <el-input v-model="alipayForm.phone" :disabled="true"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码：" prop="code" >
            <el-row :gutter="4">
              <el-col :span="16">
                  <el-input v-model="alipayForm.code" style="width: 100%;" placeholder="验证码"></el-input>
              </el-col>
              <el-col :span="4">
                  <el-button v-show="showCountDown" type="primary" @click="sendCode('alipay',alipayForm.phone)">发送验证码</el-button>
                  <el-button v-show="!showCountDown" type="primary" >{{count}}s后可重发</el-button>
              </el-col>
            </el-row> 
          </el-form-item>
      </el-form>
      <el-form style="margin-top:30px;"  :model="alipayAccountForm" ref="alipayAccountForm" :rules="alipayAccountRules"  label-width="150px" v-if="alipayActive==2">
          <el-form-item  prop="accountNumber">
              <span slot="label">
                <el-tooltip content="登录支付宝使用的账号" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                支付宝账号：
              </span>
              <el-input v-model="alipayAccountForm.accountNumber"></el-input>
          </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer" >
        <el-button type="success" v-if="alipayActive==1" @click="nextAlipay">下一步</el-button>
        <el-button type="success" v-if="alipayActive==2" @click="submitAlipay">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="支付宝绑定信息" :visible.sync="showAlipayDetailDialog" :lock-scroll="false" width="700px" v-dialogDrag center>
      <el-descriptions style="margin-left:20px" :labelStyle="{'color': '#333','font-weight': 700}"  :column="1"  border>
        <el-descriptions-item label="支付宝账号">{{userAlipayInfo.accountNumber}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
import {userWithdrawInfo,userAccountBind,userAccountNumberValidate,userAccountWxQrCode,bindWxResult,userAccountNumberDetail,saveUserBank} from "@/api/api.js";
import {userBankDetail,updateUserBank,saveUserAlipay} from "@/api/api.js";
import {userAccountNumberList,bankList} from "@/api/api.js";
import {userCommissionWithdrawList,countCommissionWithdraw} from "@/api/api.js";
import {userWithdrawalApplicationInfo,saveUserWithdrawal} from "@/api/api.js";
import {pageUserWithdrawal} from "@/api/api.js";
import {sendWithdrawalSms} from "@/api/api.js";
import {countWithdrawalCommission} from "@/api/api.js";
import {userWithdrawalRate} from "@/api/api.js";
export default {
  data() {
    return {
      activeName:"withdrawRecord",
      duigong:false,
      tableData:[],
      dialog: false,
      title:'提现申请',
      pickerEndTime:null,
      pickerOptionsEnd: {
        disabledDate: (date) => {
            if (this.pickerEndTime) {
                return date.getTime() >= new Date(this.pickerEndTime).getTime()
            }
        }
      },
      formData:{
        payMode:'2',
        type:'1',
        beginDate:null,
        endDate:null,
        endMonth:null,
        orderMoney:0,
        amountMoney:0,
        taxRate:0,
        free:0
      },
      rules:{
        remark: [
          { required: true, message: "请输入备注内容", trigger: "blur" }
        ],
        code:[
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        orderMoney:[
          { required: true, message: "请输入提现金额", trigger: "blur" }
        ],
        radio:[
          { required: true, message: "请选择提现方式", trigger: "blur" }
        ]
      },
      userRateData:{
        taxRate:0,
        wxServiceRate:0,
        alipayServiceRate:0,
        bankServiceRate:0,
        balanceServiceRate:0
      },
      userCommissionInfo:{
         totalCommissionAmount:0,
         availCommissionAmount:0,
      },
      //实名以及绑定信息
      userWithdrawInfo:{
         userCertStatus:'0',
         userWxBind:'0',
         userBankBind:'0',
         userAlipayBind:'0'
      },
      //微信绑定弹窗
      showWechatDialog:false,
      wechatTitle:'微信账号绑定',
      wechatActive:1,
      wechatForm:{
        phone:undefined,
        code:undefined
      },
      wechatRules:{
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
      },
      showCountDown:true,
      scanWxQrCode:'',
      scanWxQrCodeTimer:null,
      showWxInfoDialog: false,
      userWxAccountNumber:{
        accountNumber:undefined,
        createTime:'',
        nickname:undefined
      },

      
      bankTitle:'对公账号绑定',
      showBankDialog:false,
      bankActive:1,
      bankForm:{
        phone:undefined,
        code:undefined
      },
      backRules:{
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
      },
      bankAccountForm:{
          id:undefined,
          auditStatus:'',
          type:'1',
          bank:'',
          bankAccount:'',
          businessPhone:'',
          businessAddress:''
      },
      backAccountRules:{
        bank:[
          {required: true,message: "开户银行不能为空",trigger: "blur"}
        ],
        bankAccount:[
          {required: true,message: "开户账号不能为空",trigger: "blur"}
        ],
        businessPhone:[
          {required: true,message: "公司联系方式不能为空",trigger: "blur"}
        ],
        businessAddress:[
          {required: true,message: "公司注册地址不能为空",trigger: "blur"}
        ],
      },
      showBankDetailDialog:false,
      userBankInfo:{},
      //支付宝绑定
      showAlipayDialog:false,
      alipayActive:1,
      alipayForm:{
        phone:undefined,
        code:undefined
      },
      alipayRules:{
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
      },
      alipayAccountForm:{
          accountNumber:undefined,
      },
      alipayAccountRules:{
        accountNumber:[
          {required: true,message: "支付宝账号不能为空",trigger: "blur"}
        ],
      },
      showAlipayDetailDialog:false,
      userAlipayInfo:{
        accountNumber:undefined
      },
      state: [
        {
          key: "1",
          value: "待审核"
        },
        {
          key: "2",
          value: "审核通过"
        },
        {
          key: "3",
          value: "结算中"
        },
        {
          key: "4",
          value: "结算成功"
        },
        {
          key: "5",
          value: "结算失败"
        },
        {
          key: "6",
          value: "拒绝"
        }
      ],
      //提现记录搜索
      withdrawRecordParams:{},
      //时间范围
      dateWithdrawRange: [],
      withdrawRecordPage:1,
      withdrawRecordPageSize:10,
      totalWithdrawRecord:0,
      withdrawRecordData: [],
      withdrawableParams:{},
      countWithdrawable:{
          totalRealPayAmount:0,
          totalRebateAmount:0,
          totalRealRebateAmount:0
      },
      withdrawablePage:1,
      withdrawablePageSize:10,
      totalWithdrawable:0,
      //可提现时间
      datewithdrawableRange:[],
      withdrawableDetailData:[],
      accountData:[],
      dataBank:[],
      phone:"",
      // 倒计时的显示
      show: true,
      count: "",
      withdrawalCount: "",
      withdrawalCountDown: true,
      withdrawalTimer:null,
    };
  },
  methods: {
    handleClick(row) {
    },
    inventoryPayMode(status) {
      let obj = {
        1: "微信",
        2: "支付宝",
        3: "余额",
        4: "银行卡对公账户"
      };
      return obj[status];
    },
    inventoryOrderStatus(status) {
      let obj = {
        1: "待审核",
        2: "审核通过",
        3: "结算中",
        4: "结算成功",
        5: "结算失败",
        6: "拒绝"
      };
      return obj[status];
    },
    search() {
      this.pageUserWithdrawalMethod();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateWithdrawRange = [];
      this.resetForm("withdrawRecordParams");
      this.search();
    },
    //可提现订单
    handleWithdrawableSizeChange(pageSize) {
      this.withdrawablePageSize = pageSize;
      this.userCommissionWithdrawMethod();
    },
    handleWithdrawableCurrentChange(page) {
      this.withdrawablePage = page;
      this.userCommissionWithdrawMethod();
    },
    //提现记录
    handleWithdrawRecordSizeChange(pageSize) {
      this.withdrawRecordPageSize = pageSize;
      this.pageUserWithdrawalMethod();
    },
    handleWithdrawRecordCurrentChange(page) {
      this.withdrawRecordPage = page;
      this.pageUserWithdrawalMethod();
    },
    immediateWithdrawalClick(){
      this.userWithdrawalRateMethod();
      this.userWithdrawalApplicationInfoMethod();
      this.pickerTimeWithdrawMethod();
      this.bankListMethod();
      setTimeout(() => {
        this.calculateAmountMoneyMethod();
      }, 1000);
      this.dialog = true;
    },
    // 代理商基本信息
    userWithdrawInfoMethod(){
        userWithdrawInfo().then(res=>{
          if(res.data.code==200){
              this.userWithdrawInfo = res.data.data;
              this.wechatForm.phone = res.data.data.phone;
              this.bankForm.phone = res.data.data.phone;
              this.alipayForm.phone = res.data.data.phone;
              this.phone = res.data.data.phone;
          }
        });
    },
    withdrawRecordView(id){
      this.$router.push(`/scale/withdrawDetail/`+id);
    },
    authenticationBind(){
        this.$router.push('/authentication/userAuth')
    },
    authenticationInfo(){
        this.$router.push('/authentication/userAuthInfo')
    },
    wechatBind(){
      let that =this;
      this.userCertTip(function(){
        that.showWechatDialog = true;
      });
    },
    //微信绑定信息
    wechatBindInfo(){
      this.userWxAccountNumberDetail();
      this.showWxInfoDialog = true;
    },
    userWxAccountNumberDetail(){
        userAccountNumberDetail({type:"1"}).then(res=>{
            if(res.data.code==200){
                this.userWxAccountNumber = res.data.data;
            }
        });
    },
    userAlipayAccountNumberDetail(){
        userAccountNumberDetail({type:"2"}).then(res=>{
            if(res.data.code==200){
                this.userAlipayInfo = res.data.data;
            }
        });
    },
    userCertTip(callback){
      let status = this.userWithdrawInfo.userCertStatus;
      if(status == 0){
        this.$message({
          message: '请先完成实名认证，再绑定提现收款账号',
          type: 'warning'
        });
      }
      if(status == 1){
        this.$message({
          message: '实名认证审核中，审核成功后，再绑定提现收款账号',
          type: 'warning'
        });
      }
      if(status == 3){
        this.$message({
          message: '实名认证失败，请重新完成实名认证，再绑定提现收款账号',
          type: 'warning'
        });
      }
      if(status == 2){
        callback();
      }
    },
    bankBind(){
      let that =this;
      this.userCertTip(function(){
        that.showBankDialog = true;
      });
    },
    bankListMethod(){
        bankList().then(res=>{
          if(res.data.code == 200){
              this.dataBank = res.data.data;
          }
        })
    },
    apliayBind(){
      let that =this;
      this.userCertTip(function(){
        that.showAlipayDialog = true;
      });
    },
    // 提现关闭弹窗
    dialogClose() {
      this.dialog = false;
    },
    // 提现弹窗的取消按钮
    cancelDialog() {
      this.dialog = false;
    },
    // 提现弹窗的保存
    submitWithdraw() {
      let params = {
        ... this.formData
      }
      this.$refs["formData"].validate(valid => {
        if (valid) {
          saveUserWithdrawal(params).then(res=>{
              this.dialog = false;
              this.userWithdrawInfoMethod();
              this.userAccountNumberListMethod();
              this.countWithdrawalCommissionMethod();
              this.userCommissionWithdrawMethod();
              this.countCommissionWithdrawMethod();
              this.pageUserWithdrawalMethod();
          });
        }
      });
    },
    //微信下一步
    nextWechat(){
      let params = {
        ...this.wechatForm,
        type:'wechat'
      };
      this.$refs["wechatForm"].validate(valid => {
        if (valid) {
          userAccountNumberValidate(params).then(res=>{
              if(res.data.code == 200){
                  //进行下一步操作
                  this.wechatActive=2;
                  this.scanWechatQrCode();
                  this.scanQrCodeResult();
              }else{
                this.$message.error(res.data.message);
              }
          });
        }
      });
    },
    //扫微信二维码绑定
    scanWechatQrCode(){
      userAccountWxQrCode().then(res=>{
        this.scanWxQrCode = "data:image/jpeg;base64," + res.data.data;
      })
    },
    //扫码绑定结果查询
    scanQrCodeResult(){
      this.scanWxQrCodeTimer = setInterval(() => {
        bindWxResult().then(res => {
          if (res.data.code == 200) {
            this.wechatActive==1;
            this.showWechatDialog=false;
            clearInterval(this.scanWxQrCodeTimer);
            this.scanWxQrCodeTimer = null;
          }
        })
      },2000)
    },
    //微信弹窗
    cancelWechatDialog(){
      this.showWechatDialog=false
    },
    dialogBankClose(){
      this.showBankDialog = false;
    },
    dialogAlipayClose(){
      this.showAlipayDialog = false;
    },
    //银行绑定下一步
    nextBack(){
       let params = {
        ...this.bankForm,
        type:'bank'
      };
      this.$refs["bankForm"].validate(valid => {
        if (valid) {
          userAccountNumberValidate(params).then(res=>{
              if(res.data.code == 200){
                  //进行下一步操作
                  this.bankActive=2;
                  this.updateUserBankInfo();
              }else{
                this.$message.error(res.data.message);
              }
          });
        }
      }); 
    },
    updateUserBankInfo(){
      userBankDetail().then(res=>{
        if(res.data.code ==200 && !!res.data.data){
            this.bankAccountForm = res.data.data;
        }
      });
    },
    //银行绑定提交
    submitBank(){
        this.$refs["bankAccountForm"].validate(valid => {
          if (valid) {
            if(!!this.bankAccountForm.id){
              updateUserBank(this.bankAccountForm).then(res=>{
                if(res.data.code == 200){
                  this.showBankDialog = false;
                  this.userWithdrawInfo.userBankBind=1;
                  this.bankActive = 1;
                }else{
                  this.$message.error(res.data.message);
                }
                
              });
            }else{
              saveUserBank(this.bankAccountForm).then(res=>{
                  if(res.data.code == 200){
                      this.showBankDialog = false;
                      this.userWithdrawInfo.userBankBind=1;
                      this.bankActive = 1;
                  }else{
                    this.$message.error(res.data.message);
                  }
              });
            }
            
          }
        });
    },
    bankBindInfoMethod(){
      this.showBankDetailDialog = true;
      userBankDetail().then(res=>{
        if(res.data.code ==200){
            this.userBankInfo = res.data.data;
        }
      });
    },
    // 银行卡认证
    bankCertification(){
      this.$router.push("/scale/bankCertification");
    },
    //发送验证码
    sendCode(type,phone){
      if(!phone){
        this.$message.error('手机号不能为空!');
        return false;  
      }
      let params = {
        phone: phone,
        type: type
      };
      userAccountBind(params).then(res => {
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if ( !this.timer) {
            this.count = TIME_COUNT;
            this.showCountDown = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              }else{
                this.showCountDown = true;
                clearInterval(this.timer);
                this.timer = null
              }
            },1000)
          }
        }else{
          this.$message.error(res.data.message);
        }
      })
    },

    sendWithdrawCode(phone,money){
      if(!phone){
        this.$message.error('手机号不能为空!');
        return false;  
      }
      if(!phone){
        this.$message.error('提现金额不能为空!');
        return false; 
      }
      if(money<0){
        this.$message.error('输入金额不正确!');
        return false;
      }
      let params = {
        phone: phone,
        money: money
      };
      sendWithdrawalSms(params).then(res => {
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if ( !this.withdrawalTimer) {
            this.withdrawalCount = TIME_COUNT;
            this.withdrawalCountDown = false;
            this.withdrawalTimer = setInterval(() => {
              if (this.withdrawalCount > 0 && this.withdrawalCount <= TIME_COUNT) {
                this.withdrawalCount--;
              }else{
                this.withdrawalCountDown = true;
                clearInterval(this.withdrawalTimer);
                this.withdrawalTimer = null
              }
            },1000)
          }
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //支付宝绑定下一步
    nextAlipay(){
       let params = {
        ...this.alipayForm,
        type:'alipay'
      };
      this.$refs["alipayForm"].validate(valid => {
        if (valid) {
          userAccountNumberValidate(params).then(res=>{
              if(res.data.code == 200){
                  //进行下一步操作
                  this.alipayActive=2;
              }else{
                this.$message.error(res.data.message);
              }
          });
        }
      }); 
    },
    //支付宝绑定提交
    submitAlipay(){
        this.$refs["alipayAccountForm"].validate(valid => {
          if (valid) {
            saveUserAlipay(this.alipayAccountForm).then(res=>{
                if(res.data.code == 200){
                    this.showAlipayDialog = false;
                    this.userWithdrawInfo.userAlipayBind=1;
                    this.alipayActive = 1;
                }else{
                  this.$message.error(res.data.message);
                }
            });
          }
        });
    },
    //微信绑定信息
    alipayBindInfo(){
      this.userAlipayAccountNumberDetail();
      this.showAlipayDetailDialog = true;
    },
    //可提现记录搜索
    searchWithdrawable() {
      this.userCommissionWithdrawMethod();
      this.countCommissionWithdrawMethod();
    },
    /** 重置按钮操作 */
    resetWithdrawableQuery() {
      this.datewithdrawableRange = [];
      this.resetForm("withdrawableParams");
      this.userCommissionWithdrawMethod();
      this.countCommissionWithdrawMethod();
    },
    //可提现明细列表
    userCommissionWithdrawMethod(){
      let params = {
          model: {
            ...this.addDateRange(this.withdrawableParams, this.datewithdrawableRange)
          },
          page: this.withdrawablePage,
          pageSize: this.withdrawablePageSize
      };
      userCommissionWithdrawList(params).then(res=>{
          this.withdrawableDetailData = res.data.data.records;
          this.totalWithdrawable = res.data.data.total;
      })
    },
    //可提现佣金统计
    countCommissionWithdrawMethod(){
        let params = {
          ...this.addDateRange(this.withdrawableParams, this.datewithdrawableRange)
        };
        countCommissionWithdraw(params).then(res=>{
            this.countWithdrawable = res.data.data
        });
    },
    //用户提现信息查询
    userWithdrawalApplicationInfoMethod(){
        userWithdrawalApplicationInfo().then(res=>{
            this.formData.beginDate = res.data.data.startTime;
            this.formData.endDate = res.data.data.endTime;
            this.formData.endMonth = !!res.data.data.endTime ? this.parseTime(res.data.data.endTime,'{y}-{m}') : null
            this.pickerEndTime = res.data.data.endTime;
        })
    },
    calculateAmountMoneyMethod(){
      let payMode = this.formData.payMode;
      let money = this.formData.orderMoney;
      this.formData.taxRate = this.userRateData.taxRate;
      if(payMode == '3'){
          this.formData.free = this.userRateData.balanceServiceRate;
          let freeMoney = this.multiply(money,this.userRateData.balanceServiceRate);
          let taxMoney = this.multiply(money,this.userRateData.taxRate);
          this.formData.amountMoney = (money - freeMoney - taxMoney).toFixed(2);
      }
      if(payMode == '1'){
          this.formData.free = this.userRateData.wxServiceRate;
          let freeMoney = this.multiply(money,this.userRateData.wxServiceRate);
          let taxMoney = this.multiply(money,this.userRateData.taxRate);
          this.formData.amountMoney = (money - freeMoney - taxMoney).toFixed(2);
      }
      if(payMode == '2'){
          this.formData.free = this.userRateData.alipayServiceRate;
          let freeMoney = this.multiply(money,this.userRateData.alipayServiceRate);
          let taxMoney = this.multiply(money,this.userRateData.taxRate);
          this.formData.amountMoney = (money - freeMoney - taxMoney).toFixed(2);
      }
      if(payMode == '4'){
          this.formData.free = this.userRateData.bankServiceRate;
          let freeMoney = this.multiply(money,this.userRateData.bankServiceRate);
          let taxMoney = this.multiply(money,this.userRateData.taxRate);
          this.formData.amountMoney = (money - freeMoney - taxMoney).toFixed(2);
      }
    },
    multiply(a, b) {
        let alen = String(a).split(".")[1]; // 算出每个小数的小数点长度
        let blen = String(b).split(".")[1];

        let floatLen =!!alen?alen.length:0 + !!blen?blen.length:0; //算出结果的小数点长度
        return (a * b).toFixed(floatLen) //转化为已经知道的小数点长度的小数
    },

    //用户选择时间后的提现
    pickerTimeWithdrawMethod(){
        let params = {
          startTime:this.formData.beginDate,
          endTime:this.formData.endDate,
          endMonth:this.formData.endMonth
        };
        countCommissionWithdraw(params).then(res=>{
            this.formData.orderMoney = res.data.data.totalRealRebateAmount;
            this.formData.amountMoney = res.data.data.totalRealRebateAmount;
            this.calculateAmountMoneyMethod();
        });
    },

    //收款账号列表
    userAccountNumberListMethod(){
        userAccountNumberList().then(res=>{
          this.accountData = res.data.data
        });
    },
    //提现列表
    pageUserWithdrawalMethod(){
      let params = {
          model: {
            ...this.addDateRange(this.withdrawRecordParams, this.dateWithdrawRange)
          },
          page: this.withdrawRecordPage,
          pageSize: this.withdrawRecordPageSize
      };
      pageUserWithdrawal(params).then(res=>{
        if(res.data.code==200){
            this.withdrawRecordData = res.data.data.records;
            this.totalWithdrawRecord = res.data.data.total;
        }
      })
    },
    countWithdrawalCommissionMethod(){
        countWithdrawalCommission().then(res=>{
            if(res.data.code == 200){
              this.userCommissionInfo.totalCommissionAmount= res.data.data.totalUseMoney;
              this.userCommissionInfo.availCommissionAmount = res.data.data.canWithdrawalMoney;
            }
        })
    },
    userWithdrawalRateMethod(){
        userWithdrawalRate().then(res=>{
          if(res.data.code == 200){
            this.userRateData = res.data.data;
          }
        });
    }
    
  },
  mounted() {

  },
  created() {
    //用户提现信息
    this.userWithdrawInfoMethod();
    this.userAccountNumberListMethod();
    this.countWithdrawalCommissionMethod();
    this.userCommissionWithdrawMethod();
    this.countCommissionWithdrawMethod();
    this.pageUserWithdrawalMethod();
  }
};
</script>
<style scoped lang="less">
    .el-row{
      margin-bottom: 5px;
    }
    .el-col {
      border-radius: 4px;
    }
    .grid-content {
      border-radius: 4px;
      strong{
        color:#409EFF;
        margin-right:4px ;
      }
      span{
        color: #ECAA3C;
      }
    }
    .wecaht-image {
      text-align: center;
      margin-top:30px;
      .block {
        border-right: 1px solid #eff2f6;
        display: inline-block;
        width: 40%;
        box-sizing: border-box;
        vertical-align: top;
        
      }
      .demonstration {
        display: block;
        color: #8492a6;
        font-size: 14px;
        margin-bottom: 20px;
      }
      .el-image {
        width: 300px;
        height: 300px;
      }
    }
    
</style>


